/* eslint-disable camelcase */
/* eslint-disable indent */
import { Avatar, Button, Divider, Grid2, Icon, Tooltip } from '@mui/material'
import { styled } from '@mui/styles'
import AgriAction from 'agriAdministration/actions/AgriAction'
import Card from 'components/card/Card'
import Input from 'components/forms/Input'
import ProgressCard from 'components/card/ProgressCard'
import { push } from '@lagunovsky/redux-react-router'
import IntervenantCard from 'exploitations/components/cards/IntervenantCard'
import DtoExploitation from 'exploitations/dto/DtoExploitation'
import HomeAction from 'home/actions/HomeAction'
import InstallationAction from 'installation/actions/InstallationAction'
import DtoInstallationWithGeoItem from 'installation/components/installations/dto/DtoInstallationWithGeoItem'
import DtoInstallation from 'installation/dto/installation/DtoInstallation'
import { compact, groupBy, isEmpty, orderBy, uniqBy, isNil } from 'lodash'
import PropTypes from 'prop-types'
import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import ContactAction from 'referencial/components/contact/actions/ContactAction'
import ContactDto from 'referencial/components/contact/dto/ContactDto'
import UsageAction from 'referencial/components/usage/actions/UsageAction'
import DtoUsageAgri from 'referencial/components/usage/dto/DtoUsageAgri'
import DtoSandreCode from 'referencial/dto/DtoSandreCode'
import i18n from 'simple-react-i18n'
import TankModal from 'station/components/link/modals/TankModal'
import DtoVariousMateriel from 'station/dto/materiel/DtoVariousMateriel'
import DtoDeclaration from 'survey/dto/DtoDeclaration'
import DtoIntervenantDeclaration from 'survey/dto/DtoIntervenantDeclaration'
import DtoSamplingPointDecla from 'survey/dto/DtoSamplingPointDecla'
import DtoSurvey from 'survey/dto/DtoSurvey'
import DtoTankDeclaration from 'survey/dto/DtoTankDeclaration'
import ToastrAction from 'toastr/actions/ToastrAction'
import { mainBlue, secondaryBlue } from 'utils/constants/ColorTheme'
import { getDate } from 'utils/DateUtil'
import { hasValue } from 'utils/NumberUtil'
import { getLogin, getSetting, getUser } from 'utils/SettingUtils'
import { formatMilliers, getI18nTitleDataLength } from 'utils/StringUtil'
import CounterCard from './cards/CounterCard'
import OuvrageCard from './cards/OuvrageCard'
import PumpCard from './cards/PumpCard'
import RetenueCard from './cards/RetenueCard'
import ModalAddEquipements from './modals/ModalAddEquipements'
import ModalOuvrage from './modals/ModalOuvrage'
import ModalOwner from './modals/ModalOwner'
import ModalRemovePoint from './modals/ModalRemovePoint'
import { POINT_STATUS_DECLARATION, SITU_POINT_PUMP, SITU_PUMP_COUNTER } from 'agriAdministration/constants/AgriConstants'
import { AccordionDetailsMUI, AccordionMUI, AccordionSummaryMUI } from 'components/styled/Accordions'
import DtoExploitationExportFull from 'exploitations/dto/DtoExploitationExportFull'

const ButtonStep = styled(Button)({
    width: '100%',
})

const GridItem = styled(Grid2)({
    padding: 10,
})

const ChronicleItem = styled(Grid2)({
    padding: '4px !important',
    textAlign: 'center',
})

const TYPE_ESTIM = 1
const TYPE_INDEX = 2

class DeclarationPointDetails extends Component {
    constructor(props) {
        super(props)
        this.state = {
            openModalOuvrage: false,
            openModalOwner: false,
            owner: {},
            openModalRetenue: false,
            openModalEquipement: false,
            equipement: {},
            retenueToUpdate: false,
            openModalRemove: false,
            point: {},
            installation: {},
            usages: [],
            usagesCurrentYear: [],
            dataLoaded: false,
            readMode: props.survey?.statusCode === 3 || getUser()?.consultant === '1',
        }
    }

    componentDidMount() {
        this.props.fetchUsages()
        const { contacts } = this.props
        if (!contacts.length) {
            this.props.fetchContacts().then(() => this.getExploitation())
        } else {
            this.getExploitation()
        }
        window.scrollTo(0, 0)
    }

    getExploitation = () => {
        const { params, exploitation } = this.props
        this.props.fetchInstallation(params.idPoint).then(() => {
            if (!exploitation.idExploitation) {
                this.props.fetchExploitationUser().then(() => {
                    this.getDeclaration()
                })
            } else {
                this.getDeclaration()
            }
        })
    }

    getDeclaration = () => {
        const { params } = this.props
        this.setState({ dataLoaded: false })
        this.props.fetchDeclaration(params.idDeclaration).then((res) => {
            if (isNil(res)) {
                this.props.push('/')
                return
            }
            this.setState({ readMode: res.statusCode >= 4 || this.state.readMode })
            this.props.fetchDeclarationContributors(res.idSurvey).then(() => {
                this.setContributors(res)
            })
        })
    }

    formatContact = (contact, updatedContact) => {
        if (updatedContact) {
            return {
                ...contact,
                ...updatedContact,
                address: updatedContact.road,
                additionalAddress: updatedContact.addressComplement,
                desktopTel: updatedContact.fax,
                postalBox: updatedContact.postalCode,
            }
        }
        return contact
    }

    setContributors = (declaration) => {
        const { installation, exploitation, params, contacts, declarationContributors, survey } = this.props
        const point = declaration
            ? declaration.link_declarationInstallation.find(
                (p) => p.idInstallation === parseInt(params.idPoint),
            )
            : new DtoSamplingPointDecla({})
        const linkPoint = declaration.link_exploitationInstallation ? declaration.link_exploitationInstallation.find((p) => p.idInstallation === point.idInstallation) : null
        const ownerUpdated = declarationContributors.find((dc) => dc.link_installations.find((cI) => cI.idInstallation === installation.id && cI.surveyId === declaration.idSurvey))
        const id = ownerUpdated ? (ownerUpdated.idContributorTemp || ownerUpdated.idContributor || ownerUpdated.id) : installation.ownerCode
        const owner = ownerUpdated && ownerUpdated.idContributorTemp ? {} : (contacts.find((c) => c.id === id) || {})
        const ownerFormatted = this.formatContact(owner, ownerUpdated)
        this.setState({
            declaration,
            installation,
            point,
            linkPoint,
            usages: point.link_usages,
            owner: ownerFormatted,
            usagesCurrentYear: point.link_usagesCurrent,
            dataLoaded: true,
        })
        this.props.setTitle([{
            title: i18n.planning,
            href: 'planning',
        }, {
            title: i18n.surveys,
            href: 'planning/surveys',
        }, {
            title: `${survey.name || ''} [${survey.year || ''}]`,
            href: `survey/${survey.idSurvey}`,
        }, {
            title: `${i18n.declaration} ${exploitation.codification}`,
            href: `survey/${survey.idSurvey}/declaration/${declaration.idDeclaration}/stepper/0`,
        }, {
            title: `${i18n.pointPrelevement} ${installation.code}${installation.location ? ` - ${installation.location}` : ''}`,
            href: `survey/${survey.idSurvey}/declaration/${declaration.idDeclaration}/point/${params.idPoint}`,
        }])
    }

    toggleState = (key) => {
        this.setState({ [key]: !this.state[key] })
    }

    onCancelEquipment = () => {
        this.toggleState('openModalEquipement')
    }

    onSaveEquipment = (link_equipments, link_pumps, link_counters) => {
        const { declaration, params } = this.props
        this.setState({ dataLoaded: false })
        const link_declarationInstallation = [
            ...declaration.link_declarationInstallation.filter((p) => p.idInstallation !== parseInt(params.idPoint)),
            {
                ...declaration.link_declarationInstallation.find((p) => p.idInstallation === parseInt(params.idPoint)),
                link_equipments,
            },
        ]
        const newDeclaration = {
            ...declaration,
            lastStep: declaration.lastStep >= 3 ? declaration.lastStep : 3,
            link_declarationInstallation,
            link_pumps,
            link_counters,
        }
        this.props.updateDeclaration(newDeclaration, true).then(() => {
            this.getDeclaration()
        })
        this.toggleState('openModalEquipement')
    }

    getListUsages = (current) => {
        const { usages: usagesCat } = this.props
        const {
            usagesCurrentYear,
            usages,
        } = this.state
        const usagesSelected = current ? usagesCurrentYear : usages
        const agriUsages = []
        const nonAgriUsages = []
        usagesSelected.forEach((u) => {
            const usageCat = usagesCat.find((uCat) => uCat.idUsage === u.idUsage)
            if (usageCat && usageCat.category === 1) {
                agriUsages.push(u)
            } else if (usageCat && usageCat.category !== 1) {
                nonAgriUsages.push(u)
            }
        })

        let totalAgri = 0
        if (agriUsages.length) {
            agriUsages.forEach((u) => {
                totalAgri = totalAgri + (isNaN(u.requestedYearVolume) ? 0 : u.requestedYearVolume)
            })
        }
        let totalNonAgri = 0
        if (nonAgriUsages.length) {
            nonAgriUsages.forEach((u) => {
                totalNonAgri = totalNonAgri + (isNaN(u.requestedYearVolume) ? 0 : u.requestedYearVolume)
            })
        }
        return (
            <Grid2
                container
                direction='column'
                justifyContent='center'
                spacing={1}
            >
                <Input
                    col={12}
                    className='padding-left-1 padding-top-1'
                    title={i18n.agri}
                    value={`${agriUsages.length} ${agriUsages.length > 1 ? i18n.usages : i18n.usage} (${formatMilliers(totalAgri) || 0} m3)`}
                    readMode
                />
                <Input
                    col={12}
                    className='padding-left-1 padding-top-1'
                    title={i18n.nonAgri}
                    value={`${nonAgriUsages.length} ${nonAgriUsages.length > 1 ? i18n.usages : i18n.usage} (${formatMilliers(totalNonAgri) || 0} m3)`}
                    readMode
                />
            </Grid2>
        )
    }

    onValidePoint = (declaration) => {
        this.props.push(`/survey/${declaration.idSurvey}/declaration/${declaration.idDeclaration}/stepper/3`)
    }

    onSaveOwner = (ownerUpdated) => {
        const { installation, declaration } = this.props
        const { owner } = this.state
        const id = ownerUpdated.idContributorTemp || ownerUpdated.idContributor || ownerUpdated.id

        const newLink = {
            surveyId: declaration.idSurvey,
            idInstallation: installation.id,
            updateLogin: getLogin(),
        }

        const ownerFormatted = {
            ...ownerUpdated,
            road: ownerUpdated.address,
            addressComplement: ownerUpdated.additionalAddress,
            fax: ownerUpdated.desktopTel,
            postalCode: ownerUpdated.postalBox,
            idContributor: id,
            surveyId: declaration.idSurvey,
            contactType: 2,
        }
        // si on utilise un contact existant
        if (!isEmpty(ownerUpdated)) {
            if (id) {
                this.setState({ dataLoaded: false })
                // si on change de propriétaire
                if ((ownerUpdated.idContributorTemp && owner.idContributorTemp && ownerUpdated.idContributorTemp !== owner.idContributorTemp) ||
                    (id !== (owner.idContributor || owner.id))) {
                    this.props.updateDeclarationContributor(declaration.idSurvey, {
                        ...ownerFormatted,
                        link_installations: [
                            ...(ownerUpdated.link_installations || []),
                            {
                                ...newLink,
                                idContributor: id,
                                isTemp: !!ownerUpdated.idContributorTemp,
                            },
                        ],
                    }).then(() => {
                        this.getDeclaration()
                    })
                // si on modifie les infos du propriétaire actuel
                } else {
                    this.props.updateDeclarationContributor(declaration.idSurvey, {
                        ...ownerFormatted,
                        link_installations: [
                            ...(ownerUpdated.link_installations || []),
                            {
                                ...newLink,
                                idContributor: id,
                                isTemp: !!ownerUpdated.idContributorTemp,
                            },
                        ],
                    }).then(() => {
                        this.getDeclaration()
                    })
                }
            } else if (!id) {
                this.setState({ dataLoaded: false })
                this.props.updateDeclarationContributor(declaration.idSurvey, ownerFormatted).then((idReturned) => {
                    this.props.updateDeclarationContributor(declaration.idSurvey, {
                        ...ownerFormatted,
                        idContributorTemp: idReturned,
                        link_installations: [
                            ...(ownerUpdated.link_installations || []),
                            {
                                ...newLink,
                                idContributor: idReturned,
                                isTemp: true,
                            },
                        ],
                    }).then(() => {
                        this.getDeclaration()
                    })
                })
            }
            this.toggleState('openModalOwner')
        } else {
            this.props.warning('Veuillez renseigner un propriétaire')
        }
    }

    onDeclareUnused = (declaration) => {
        const { point } = this.state
        const points = declaration.link_declarationInstallation.filter(
            (p) => p.idInstallation !== point.idInstallation,
        )
        const newDeclaration = {
            ...declaration,
            lastStep: declaration.lastStep >= 3 ? declaration.lastStep : 3,
            link_declarationInstallation: points,
        }
        this.props.updateDeclaration(newDeclaration).then(() => {
            this.toggleState('openModalRemove')
            this.props.push(`/survey/${declaration.idSurvey}/declaration/${declaration.idDeclaration}/stepper/3`)
        })
    }

    onDeclareUsed = (declaration) => {
        const { point } = this.state
        const pointToRemove = declaration.link_declarationInstallation.find((p) => p.idInstallation === point.idInstallation)
        const points = [...declaration.link_declarationInstallation.filter(
            (p) => p.idInstallation !== point.idInstallation,
        ), {
            ...pointToRemove,
            stateCode: POINT_STATUS_DECLARATION.USED,
        }]
        const newDeclaration = {
            ...declaration,
            lastStep: declaration.lastStep >= 3 ? declaration.lastStep : 3,
            link_declarationInstallation: points,
        }
        this.props.updateDeclaration(newDeclaration).then(() => {
            this.toggleState('openModalRemove')
            this.props.push(`/survey/${declaration.idSurvey}/declaration/${declaration.idDeclaration}/stepper/3`)
        })
    }

    onDeclareAdjourn = (declaration) => {
        const { point } = this.state
        const pointToRemove = declaration.link_declarationInstallation.find((p) => p.idInstallation === point.idInstallation)
        const points = [...declaration.link_declarationInstallation.filter(
            (p) => p.idInstallation !== point.idInstallation,
        ), {
            ...pointToRemove,
            stateCode: POINT_STATUS_DECLARATION.ADJOURNED,
            link_usages: [],
        }]
        const newDeclaration = {
            ...declaration,
            lastStep: declaration.lastStep >= 3 ? declaration.lastStep : 3,
            link_declarationInstallation: points,
        }
        this.props.updateDeclaration(newDeclaration).then(() => {
            this.toggleState('openModalRemove')
            this.props.push(`/survey/${declaration.idSurvey}/declaration/${declaration.idDeclaration}/stepper/3`)
        })
    }

    onRemovePoint = (declaration) => {
        const { point } = this.state
        const pointToRemove = declaration.link_declarationInstallation.find((p) => p.idInstallation === point.idInstallation)
        const points = [...declaration.link_declarationInstallation.filter(
            (p) => p.idInstallation !== point.idInstallation,
        ), {
            ...pointToRemove,
            stateCode: POINT_STATUS_DECLARATION.REMOVED,
        }]
        const newDeclaration = {
            ...declaration,
            lastStep: declaration.lastStep >= 3 ? declaration.lastStep : 3,
            link_declarationInstallation: points,
        }
        this.props.updateDeclaration(newDeclaration).then(() => {
            this.toggleState('openModalRemove')
            this.props.push(`/survey/${declaration.idSurvey}/declaration/${declaration.idDeclaration}/stepper/3`)
        })
    }

    goToUsages = (type) => {
        const { params } = this.props
        this.props.push(`/survey/${params.id}/declaration/${params.idDeclaration}/usages/${params.idPoint}/${type}`)
    }

    getAssociatedResources = () => {
        const { linkPoint } = this.state
        return linkPoint ? linkPoint.link_samples[0] : null
    }

    getTypePrel = (key) => {
        switch (key) {
            case 1:
                return 'PREL_AGRI.NATURE_PRELEVEMENT_ESO'
            case 2:
                return 'PREL_AGRI.NATURE_PRELEVEMENT_ESU'
            default:
                return 'PREL_AGRI.NATURE_PRELEVEMENT'
        }
    }

    getNature = () => {
        const associatedResources = this.getAssociatedResources()
        if (associatedResources) {
            const { sandreCodes } = this.props
            const codeType = this.getTypePrel(associatedResources.sampleType)
            const codeFind = sandreCodes.find((c) => c.field === codeType && c.code === associatedResources.sampleNature)
            return codeFind ? codeFind.name : ''
        }
        return ''
    }

    getOuvrages = () => {
        const { point, linkPoint, openModalOuvrage, readMode } = this.state
        if (linkPoint?.link_sampleCasings?.length) {
            return (
                linkPoint.link_sampleCasings.map((ouvrage) => {
                    const updatedOuvrage = point.link_sampleCasings.find((o) => o.idInstallation === ouvrage.idInstallation)
                    const ouvrageDecla = {
                        ...ouvrage,
                        ...updatedOuvrage,
                    }
                    return (
                        <GridItem size={6} id={ouvrageDecla.id} key={ouvrageDecla.id}>
                            <OuvrageCard
                                title={i18n.work}
                                ouvrage={ouvrageDecla}
                                actions={readMode ? [] : [{ onClick: () => this.toggleState('openModalOuvrage'), iconName: 'edit' }]}
                                style={{ height: '100%' }}
                                round
                            />
                            {openModalOuvrage && (
                                <ModalOuvrage
                                    ouvrage={ouvrageDecla}
                                    open={openModalOuvrage}
                                    onCancel={this.onCancelOuvrage}
                                    onValidate={this.onSaveOuvrage}
                                    surveyMode
                                />
                            )}
                        </GridItem>
                    )
                })
            )
        }
        return (
            <GridItem size={6}>
                <OuvrageCard
                    title={i18n.work}
                    style={{ height: '100%' }}
                    round
                />
            </GridItem>
        )
    }

    onCancelOuvrage = () => {
        this.toggleState('openModalOuvrage')
    }

    onSaveOuvrage = (ouvrage) => {
        const { point } = this.state
        const { declaration, exploitation } = this.props
        const updatedDeclaration = {
            ...declaration,
            lastStep: declaration.lastStep >= 3 ? declaration.lastStep : 3,
            link_declarationInstallation: [
                ...declaration.link_declarationInstallation.filter((p) => p.idInstallation !== point.idInstallation),
                {
                    ...point,
                    link_sampleCasings: [{
                        ...ouvrage,
                        idSurvey: declaration.idSurvey,
                        idExploitation: exploitation.idExploitation,
                        idInstallation: point.idInstallation,
                    }],
                },
            ],
        }
        this.props.updateDeclaration(updatedDeclaration, true).then(() => {
            this.getDeclaration()
            this.toggleState('openModalOuvrage')
        })
    }

    getRetenues = () => {
        const { linkPoint, point, readMode } = this.state
        const length = linkPoint?.link_sampleTanks?.length || 0
        const title = getI18nTitleDataLength(`${i18n.detention} (${length} ${i18n.element})`, `${i18n.detentions} (${length} ${i18n.elements})`, length)
        return (
            <GridItem size={6}>
                <AccordionMUI defaultExpanded={false} round>
                    <AccordionSummaryMUI round color={secondaryBlue}>
                        {title}
                    </AccordionSummaryMUI>
                    <AccordionDetailsMUI round>
                    {length ? (
                        <Grid2 container direction='column'>
                            {linkPoint.link_sampleTanks.map((retenue) => {
                                const updatedRetenue = point.link_sampleTanks.find((o) => o.idTank === retenue.idTank)
                                const retenueDecla = updatedRetenue ? {
                                    ...retenue,
                                    ...new DtoTankDeclaration(updatedRetenue),
                                    link_periodes: updatedRetenue?.link_periodes?.length ? [...updatedRetenue?.link_periodes] : [...retenue.link_periodes],
                                } : retenue
                                return (
                                    <RetenueCard
                                        id={retenueDecla.idTank}
                                        key={retenueDecla.idTank}
                                        title={retenueDecla.id || i18n.noName}
                                        retenue={retenueDecla}
                                        actions={readMode ? [] : [{ onClick: () => this.editRetenue(retenueDecla), iconName: 'edit' }]}
                                        className='margin-bottom-1'
                                        round
                                    />
                                )
                            })}
                        </Grid2>
                    ) : i18n.noTank}
                    </AccordionDetailsMUI>
                </AccordionMUI>
            </GridItem>
        )
    }

    onCancelRetenue = () => {
        this.setState({ retenueToUpdate: false })
        this.toggleState('openModalRetenue')
    }

    onSaveRetenue = (retenue) => {
        const { point } = this.state
        const { declaration, exploitation } = this.props
        const updatedDeclaration = {
            ...declaration,
            lastStep: declaration.lastStep >= 3 ? declaration.lastStep : 3,
            link_declarationInstallation: [
                ...declaration.link_declarationInstallation.filter((p) => p.idInstallation !== point.idInstallation),
                {
                    ...point,
                    link_sampleTanks: [
                        ...point.link_sampleTanks.filter((t) => t.idTank !== retenue.idTank),
                        {
                            ...retenue,
                            idSurvey: declaration.idSurvey,
                            idExploitation: exploitation.idExploitation,
                            idInstallation: point.idInstallation,
                            link_periodes: (retenue.link_periodes || []).map((l) => ({
                                ...l,
                                idTank: retenue.idTank,
                                idSurvey: declaration.idSurvey,
                                updateLogin: getLogin(),
                            })),
                        }],
                },
            ],
        }
        this.props.updateDeclaration(updatedDeclaration).then(() => {
            this.getDeclaration()
            this.setState({ retenueToUpdate: false })
            this.toggleState('openModalRetenue')
        })
    }

    editRetenue = (retenue) => {
        this.setState({ retenueToUpdate: retenue })
        this.toggleState('openModalRetenue')
    }

    getExploitationEquipments = () => {
        const { declaration, variousMateriels } = this.props
        const { point } = this.state
        const matsSituPoint = compact(declaration.link_exploitationMateriel.map((m) => {
            const matFound = variousMateriels.find((vM) => vM.id === m.idVarious && (!vM.administrator || (vM.administrator === declaration.idContributor) || vM.isShared))
            if (m.siteType === SITU_POINT_PUMP && m.siteCode === point.idInstallation && matFound) {
                return {
                    ...m,
                    shared: hasValue(matFound.administrator) && matFound.isShared,
                }
            }
            return null
        })) || []
        let matsSituOthers = []
        declaration.link_exploitationMateriel.forEach((m) => {
            const matFound = variousMateriels.find((vM) => vM.id === m.idVarious && (!vM.administrator || (vM.administrator === declaration.idContributor) || vM.isShared))
            if (!matsSituPoint.find((mP) => mP.idVarious === m.idVarious) &&
                !matsSituOthers.find((mO) => mO.idVarious === m.idVarious) &&
                m.siteType === SITU_POINT_PUMP &&
                declaration.link_exploitationInstallation.find((p) => m.siteCode === p.idInstallation) && matFound) {
                matsSituOthers.push({
                    ...m,
                    shared: hasValue(matFound.administrator) && matFound.isShared,
                })
            }
        })
        return uniqBy([...matsSituPoint, ...matsSituOthers], v => [v.idVarious, v.siteCode, v.siteCode, v.siteType, v.statusCode].join())
    }

    getUpdatedMats(declaration) {
        const { point } = this.state

        const link_equipments = declaration.link_declarationInstallation.find((p) => p.idInstallation === point.idInstallation).link_equipments || []
        const materielsSelected = this.getExploitationEquipments().filter((m) => m.siteCode === point.idInstallation) // pompes installées initialement
        const newMats = link_equipments.filter((mLink) => !mLink.idMatAttachment && mLink.mode === 'c') // pompes ajoutées
        const deletedMats = link_equipments.filter((mLink) => !mLink.idMatAttachment && mLink.mode === 'd') // pompes supprimées

        const newSelectedMatsSitu = compact(newMats.map((mLink) => {
            return declaration.link_exploitationMateriel.find((mSitu) => mSitu.idVarious === mLink.idMat)
        }))
        const mergedSelectedMatSitu = compact([ // Pompes actuellement sur le point
            ...materielsSelected.filter((m) => !deletedMats.find((mLink) => m.idVarious === mLink.idMat)),
            ...newSelectedMatsSitu,
        ])

        const linkAssignments = link_equipments.filter((linkE) => linkE.assignmentRate)

        let linkCounters = link_equipments.filter((linkE) => linkE.idMatAttachment).map((linkE) => { // Liens entre pompes et compteurs
            return {
                idPump: linkE.idMat,
                idCounter: linkE.idMatAttachment,
                mode: linkE.mode,
            }
        })
        mergedSelectedMatSitu.forEach((mat) => {
            const counterSitu = declaration.link_exploitationMateriel.find((mSitu) => mSitu.siteType === SITU_PUMP_COUNTER && mat.idVarious === mSitu.siteCode)
            if (counterSitu && !linkCounters.find((linkC) => linkC.idPump === counterSitu.siteCode && linkC.idCounter === counterSitu.idVarious)) {
                linkCounters.push({
                    idPump: counterSitu.siteCode,
                    idCounter: counterSitu.idVarious,
                    mode: 'u',
                })
            }
        })
        return {
            mergedSelectedMatSitu: uniqBy(mergedSelectedMatSitu, v => [v.idVarious, v.siteCode, v.siteCode, v.siteType, v.statusCode].join()),
            linkAssignments,
            linkCounters,
        }
    }

    getEquipments = () => {
        const { readMode, declaration } = this.state
        const { variousMateriels, exploitation, params, contributorsIndex } = this.props
        if (variousMateriels.length) {
            const { mergedSelectedMatSitu = [], linkAssignments = [], linkCounters = [] } = this.getUpdatedMats(declaration)
            const length = mergedSelectedMatSitu.length
            const title = getI18nTitleDataLength(`${i18n.materiel} (${length} ${i18n.element})`, `${i18n.materiels} (${length} ${i18n.elements})`, length)
            return (
                <GridItem size={6}>
                    <AccordionMUI defaultExpanded={false} round>
                        <AccordionSummaryMUI round color={secondaryBlue}>
                            <Grid2 container justifyContent='space-between' alignItems='center' className='padding-right-1' size={12}>
                                {title}
                                {!readMode && (
                                    <Icon
                                        fontSize='large'
                                        onClick={(e) => {
                                            e.stopPropagation()
                                            this.toggleState('openModalEquipement')
                                        }}
                                    >
                                        edit
                                    </Icon>
                                )}
                            </Grid2>
                        </AccordionSummaryMUI>
                        <AccordionDetailsMUI round>
                            <Grid2 container direction='column'>
                                {mergedSelectedMatSitu.map((d) => {
                                    const matPump = variousMateriels.find((m) => m.id === d.idVarious) || {}
                                    const pump = matPump.pump || {}
                                    const pumpAssignmentRate = linkAssignments.find((lA) => lA.idMat === d.idVarious && !lA.idMatAttachment)
                                    const pumpRep = exploitation.link_repartition_materiels.find((m) => m.linkType === 1 && m.idElement1 === parseInt(params.idPoint) && m.idElement2 === d.idVarious)
                                    const pompeInfos = {
                                        ...declaration.link_exploitationMateriel.find((m) => m.siteType === SITU_PUMP_COUNTER && m.siteCode === d.idVarious),
                                        ...matPump,
                                        ...pump,
                                        ...declaration.link_pumps.find((p) => p.id === d.idVarious),
                                        assignmentRate: pumpAssignmentRate ? pumpAssignmentRate?.assignmentRate : pumpRep?.repartition,
                                        shared: hasValue(matPump.administrator) && matPump.isShared,
                                    }
                                    const allCompteursInfo = compact(linkCounters.filter((lC) => lC.idPump === d.idVarious && lC.mode !== 'd').map((lC) => {
                                        const matCounter = variousMateriels.find((c) => c.id === lC.idCounter)
                                        const counterAssignmentRate = linkAssignments.find((lA) => lA.idMat === d.idVarious && lA.idMatAttachment === lC.idCounter)
                                        const counterRep = exploitation.link_repartition_materiels.find((m) => m.linkType === 2 && m.idElement1 === d.idVarious && m.idElement2 === lC.idCounter)
                                        if (matCounter) {
                                            const counter = matCounter.counter || {}
                                            return {
                                                ...matCounter,
                                                ...counter,
                                                ...declaration.link_counters.find((c) => c.id === lC.idCounter),
                                                assignmentRate: counterAssignmentRate ? counterAssignmentRate?.assignmentRate : counterRep?.repartition,
                                                shared: hasValue(matCounter.administrator) && matCounter.isShared,
                                            }
                                        }
                                        return null
                                    }))
                                    return (
                                        <Fragment key={matPump.id}>
                                            <PumpCard
                                                title={`${i18n.pumpingEquipment} ${pompeInfos.reference || ''}`}
                                                pump={pompeInfos}
                                                actions={pompeInfos.shared ? [{ iconName: 'people', tooltip: `${i18n.shared} (${i18n.administrator} : ${contributorsIndex[matPump.administrator]?.name})` }] : []}
                                            />
                                            {allCompteursInfo.map((counter) => (
                                                <CounterCard
                                                    key={counter.id}
                                                    title={`${i18n.countingDevice} ${counter.reference || ''}`}
                                                    counter={counter}
                                                    actions={counter.shared ? [{ iconName: 'people', tooltip: `${i18n.shared} (${i18n.administrator} : ${contributorsIndex[counter.administrator]?.name})` }] : []}
                                                />
                                            ))}
                                        </Fragment>
                                    )
                                })}
                            </Grid2>
                        </AccordionDetailsMUI>
                    </AccordionMUI>
                </GridItem>
            )
        }
        return ''
    }

    getMateriels = () => {
        const { declaration, params } = this.props
        const link_equipments = declaration.link_declarationInstallation.find((p) => p.idInstallation === parseInt(params.idPoint)).link_equipments || []
        const newMats = link_equipments.filter((mLink) => !mLink.idMatAttachment && mLink.mode !== 'd')
        const deletedMats = link_equipments.filter((mLink) => !mLink.idMatAttachment && mLink.mode === 'd')
        const deletedCounters = link_equipments.filter((mLink) => mLink.idMatAttachment && mLink.mode === 'd')
        const exploitationPumps = declaration.link_exploitationMateriel.filter((m) => m.siteType === 7 && m.siteCode === parseInt(params.idPoint) && !deletedMats.find((mLink) => m.idVarious === mLink.idMat)) || []
        const mergedPumpsIds = uniqBy([
            ...exploitationPumps.map((m) => m.idVarious),
            ...newMats.map((m) => m.idMat),
        ], obj => obj)
        const exploitationCountersId = compact(mergedPumpsIds.flatMap((pumpId) => {
            const pumpSitu = declaration.link_exploitationMateriel.filter((situ) => situ.siteType === 8 && situ.siteCode === pumpId && !deletedCounters.find((mLink) => pumpId === mLink.idMat))
            if (pumpSitu) {
                return pumpSitu.map((s) => s.idVarious)
            }
            return null
        }))
        const newCounters = link_equipments.filter((mLink) => mLink.idMatAttachment && mLink.mode !== 'd' && mergedPumpsIds.includes(mLink.idMat))
        const mergedCountersIds = uniqBy([
            ...exploitationCountersId,
            ...newCounters.map((m) => m.idMatAttachment),
        ], obj => obj)
        return [mergedPumpsIds, mergedCountersIds]
    }

    getEvolValue = (type, chronicles, chronicle, index) => {
        if (type === TYPE_INDEX) {
            return chronicle.value - chronicles[index + 1].value
        }
        return Math.round(chronicles.slice(index).reduce((acc, d) => acc + d.value, 0))
    }

    getChroniclesByType = (chroniclesByType, type, readingCoefficient = 1) => {
        if (chroniclesByType?.length) {
            const orderedChronicles = orderBy(chroniclesByType, ['measureDate', 'endDate', 'value'], ['desc', 'desc', 'desc'])
            return (
                <>
                    <ChronicleItem className='italic-label' size={3}>
                        {type === TYPE_ESTIM ? i18n.startDate : i18n.statementDate}
                    </ChronicleItem>
                    <ChronicleItem className='italic-label' size={3}>
                        {type === TYPE_ESTIM ? i18n.endDate : ''}
                    </ChronicleItem>
                    <ChronicleItem className='italic-label' size={3}>
                        {type === TYPE_ESTIM ? i18n.estimateM3 : i18n.index}
                    </ChronicleItem>
                    <ChronicleItem className='italic-label' size={3}>
                        {type === TYPE_ESTIM ? i18n.stack : i18n.evolution}
                    </ChronicleItem>
                    {compact(orderedChronicles.map((chronicle, i) => {
                        const valueEvol = i !== orderedChronicles.length - 1 ? this.getEvolValue(type, orderedChronicles, chronicle, i) : null
                        return (i > 4) ? null : (
                            <>
                                <ChronicleItem size={3}>
                                    {getDate(chronicle.measureDate)}
                                </ChronicleItem>
                                <ChronicleItem size={3}>
                                    {chronicle.endDate ? getDate(chronicle.endDate) : ''}
                                </ChronicleItem>
                                <ChronicleItem size={3}>
                                    {`${formatMilliers(chronicle.value) || 0}${chronicle.measureType === 1 ? ' m3' : ''}`}
                                </ChronicleItem>
                                <ChronicleItem size={3} style={ valueEvol < 0 ? { color: 'orange' } : {}}>
                                    {hasValue(valueEvol) ? ` ${valueEvol < 0 ? '-' : '+'} ${formatMilliers(Math.abs((valueEvol) * readingCoefficient))} m3` : ''}
                                </ChronicleItem>
                            </>
                        )
                    }))}
                    {orderedChronicles.length > 5 && <ChronicleItem size={11}>...</ChronicleItem>}
                    <ChronicleItem size={11}>
                        <Divider />
                    </ChronicleItem>
                </>
            )
        }
        return null
    }

    getChronicles = () => {
        const { declaration, variousMateriels, exploitation, contributorsIndex } = this.props
        const { point } = this.state
        const [pumpsId, countersId] = this.getMateriels()
        const allIds = [...pumpsId, ...countersId]
        const linkPoint = exploitation.link_samplings.find((l) => l.idInstallation === point.idInstallation) || {}
        const groupedByMat = Object.values(groupBy(declaration.link_chronicles.filter((c) => allIds.includes(c.idMat) && (!linkPoint.startDate || c.measureDate >= linkPoint.startDate) && (!linkPoint.endDate || c.measureDate < linkPoint.endDate)), 'idMat'))
        return compact(groupedByMat.map((chronicles) => {
            const variousMat = variousMateriels.find((mat) => mat.id === chronicles[0].idMat) || {}
            const shared = hasValue(variousMat.administrator) && variousMat.isShared
            if (!hasValue(variousMat.administrator) || (variousMat.administrator === exploitation.operatorCode) || variousMat.isShared) {
                const indexChronicles = chronicles.filter((c) => c.measureType === TYPE_INDEX)
                const estimateChronicles = chronicles.filter((c) => c.measureType === TYPE_ESTIM)
                const counterUpdated = declaration.link_counters.find((c) => c.id === variousMat.id) || {}
                const readingCoefficient = counterUpdated.readingCoefficient || variousMat?.counter?.readingCoefficient
                return (
                    <Grid2
                        size={12}
                        container
                        direction='row'
                        justifyContent='center'
                        key={variousMat.id}
                    >
                        <ChronicleItem size={11} className='bold' container alignItems='center'>
                            {variousMat.reference}{readingCoefficient ? ` - ${i18n.readingCoefficient} ${readingCoefficient}` : ''}
                            {variousMat?.counter?.informative && ` (${i18n.informative})`}
                            {shared && (
                                <Tooltip title={`${i18n.shared} (${i18n.administrator} : ${contributorsIndex[variousMat.administrator]?.name})`}>
                                    <Icon className='margin-left-1'>
                                        people
                                    </Icon>
                                </Tooltip>
                            )}
                        </ChronicleItem>
                        {this.getChroniclesByType(indexChronicles, TYPE_INDEX, readingCoefficient)}
                        {this.getChroniclesByType(estimateChronicles, TYPE_ESTIM)}
                    </Grid2>
                )
            }
            return null
        }))
    }

    getLineRepartition = (link) => {
        const { exploitationsExportFullData } = this.props
        const exploitationFound = exploitationsExportFullData.find((e) => e.idExploitation === link.idExploitation) || {}
        return (
            <>
                <span>{exploitationFound.codification} : {hasValue(link.distribution) ? `${link.distribution} %` : i18n.unknown}</span><br />
            </>
        )
    }

    render() {
        const {
            openModalOwner,
            openModalRetenue,
            openModalRemove,
            openModalEquipement,
            installation,
            owner,
            retenueToUpdate,
            dataLoaded,
            point,
            readMode,
        } = this.state
        const { declaration = {}, survey, exploitation } = this.props
        const linkPoint = exploitation.link_samplings.find((l) => l.idInstallation === installation.id) || {}
        const link_shared = linkPoint.link_shared || []
        const pointIsShared = link_shared.filter((p) => p.idExploitation !== exploitation.idExploitation).length > 0
        const total = link_shared.reduce((acc, l) => acc + (l.distribution || 0), 0)
        const tooltip = (
            <>
                {link_shared.map((p) => this.getLineRepartition(p))}
                <span className='bold'>{i18n.total} : {`${total} %`}</span><br />
            </>
        )
        if (dataLoaded) {
            return (
                <>
                    <Grid2
                        container
                        alignItems='center'
                        justifyContent='center'
                        sx={{
                            padding: '0 10px',
                            backgroundColor: 'white',
                            height: '60px',
                            borderBottom: '1px solid grey',
                        }}
                    >
                        <Grid2 size={2} md={1}>
                            <Avatar sx={{ color: 'white', backgroundColor: `${mainBlue}`, textAlign: 'center' }}>3/4</Avatar>
                        </Grid2>
                        <Grid2 size={10}>
                            <h5 className='italic-label'>{i18n.iCheckMySamplingPoint}</h5>
                        </Grid2>
                    </Grid2>
                    <Grid2 size={12} container alignItems='center'>
                        <GridItem size={2}>
                            <p style={{ display: 'flex', alignItems: 'center' }}>
                                <span className='bold'>{i18n.code} : </span>
                                {installation.code}
                                {pointIsShared && (
                                    <Tooltip title={tooltip}>
                                        <Icon sx={{ marginLeft: '5px' }}>people</Icon>
                                    </Tooltip>
                                )}
                            </p>
                            <p><span className='bold'>{i18n.name} : </span>{installation.name}</p>
                        </GridItem>
                        <GridItem size={2}>
                            <p><span className='bold'>{i18n.sampleNature} : </span>{this.getNature()}</p>
                            <p><span className='bold'>{i18n.location} : </span>{installation.location}</p>
                        </GridItem>
                        <GridItem size={8}>
                            <p><span className='bold'>{i18n.descriptive} : </span>{installation.descriptive}</p>
                            <p><span className='bold'>{i18n.comment} : </span>{installation.comments}</p>
                        </GridItem>
                    </Grid2>
                    <Grid2
                        container
                        size={12}
                        direction='column'
                        justifyContent='flex-start'
                    >
                        <Grid2 container alignItems='flex-start' justifyContent='flex-start' sx={{ paddingBottom: '60px' }}>
                            <Grid2 size={8} container justifyContent='flex-start'>
                                <Grid2 size={12} container alignItems='stretch' justifyContent='flex-start' className='padding-bottom-1'>
                                    <GridItem size={6}>
                                        <IntervenantCard
                                            title={i18n.owner}
                                            intervenant={owner}
                                            actions={readMode ? [] : [{ onClick: () => this.toggleState('openModalOwner'), iconName: 'edit' }]}
                                            style={{ height: '100%' }}
                                            round
                                        />
                                    </GridItem>
                                    {this.getOuvrages()}
                                </Grid2>
                                <Grid2 size={12} container alignItems='stretch' justifyContent='flex-start'>
                                    {this.getRetenues()}
                                    {this.getEquipments()}
                                </Grid2>
                            </Grid2>
                            <Grid2 size={4} container direction='column' alignItems='stretch' justifyContent='flex-start'>
                                {((getSetting(survey.link_params, 'usagesReal') || '1') === '1' || (getSetting(survey.link_params, 'consos') || '1') === '1') && (
                                    <GridItem>
                                        <Card
                                            title={`${i18n.consos} ${survey.surveyType === 2 ? survey?.year : survey?.year - 1}`}
                                            headerStyle={{ backgroundColor: secondaryBlue }}
                                            actions={[{ onClick: () => this.goToUsages('reel'), iconName: 'edit' }]}
                                            style={{
                                                border: `1px solid ${secondaryBlue}`,
                                                borderWidth: '0 2 2 2',
                                            }}
                                            round
                                        >
                                            <div className='padding-1'>
                                                {(getSetting(survey.link_params, 'usagesReal') || '1') !== '0' && this.getListUsages(true)}
                                                <Grid2 className='padding-1'>
                                                    <Divider />
                                                </Grid2>
                                                {(getSetting(survey.link_params, 'consos') || '1') !== '0' && this.getChronicles()}
                                            </div>
                                        </Card>
                                    </GridItem>
                                )}
                                {(getSetting(survey.link_params, 'usagesPrevi') || '1') !== '0' && (
                                    <GridItem>
                                        <Card
                                            title={`${i18n.anticipation} ${survey.year}`}
                                            headerStyle={{ backgroundColor: secondaryBlue }}
                                            actions={[{ onClick: () => this.goToUsages('previ'), iconName: 'edit' }]}
                                            style={{
                                                border: `1px solid ${secondaryBlue}`,
                                                borderWidth: '0 2 2 2',
                                            }}
                                            round
                                        >
                                            <div className='padding-1'>
                                                {this.getListUsages(false)}
                                            </div>
                                        </Card>
                                    </GridItem>
                                )}
                            </Grid2>
                        </Grid2>
                        <Grid2
                            container
                            direction='row'
                            justifyContent='space-around'
                            alignItems='center'
                            sx={{
                                position: 'fixed',
                                bottom: 0,
                                height: '60px',
                                backgroundColor: 'white',
                                borderTop: '1px solid grey',
                                width: 'calc(100% - 60px)',
                            }}
                        >
                            <Grid2 size={2}>
                                <ButtonStep
                                    variant='contained'
                                    color='primary'
                                    onClick={() => this.toggleState('openModalRemove')}
                                    disabled={readMode}
                                >
                                    {i18n.changeStatusPoint}
                                </ButtonStep>
                            </Grid2>
                            <Grid2 size={2} />
                            <Grid2 size={2}>
                                <ButtonStep variant='contained' color='primary' onClick={() => this.onValidePoint(declaration)}>
                                    {i18n.validate}
                                    <Icon sx={{ marginLeft: '10px' }}>check</Icon>
                                </ButtonStep>
                            </Grid2>
                        </Grid2>
                    {openModalRemove && (
                        <ModalRemovePoint
                            open={openModalRemove}
                            onDeclareUsed={() => this.onDeclareUsed(declaration)}
                            onDeclareUnused={() => this.onDeclareUnused(declaration)}
                            onDeclareAdjourn={() => this.onDeclareAdjourn(declaration)}
                            onRemovePoint={() => this.onRemovePoint(declaration)}
                            onCancel={() => this.toggleState('openModalRemove')}
                            pointStatus={declaration.link_declarationInstallation.find((p) => p.idInstallation === point.idInstallation).stateCode}
                        />
                    )}
                    {openModalRetenue && (
                        <TankModal
                            tank={retenueToUpdate}
                            open={openModalRetenue}
                            onCancel={this.onCancelRetenue}
                            onValidate={this.onSaveRetenue}
                            lockId
                        />
                    )}
                    {openModalOwner && (
                        <ModalOwner
                            owner={owner || {}}
                            open={openModalOwner}
                            onCancel={() => this.toggleState('openModalOwner')}
                            onSave={this.onSaveOwner}
                        />
                    )}
                    {openModalEquipement && (
                        <ModalAddEquipements
                            open={openModalEquipement}
                            materiels={this.getExploitationEquipments().filter(({ shared }) => !shared)}
                            point={point}
                            declaration={declaration}
                            onSave={this.onSaveEquipment}
                            onCancel={this.onCancelEquipment}
                        />
                    )}
                    </Grid2>
                </>
            )
        }
        return <ProgressCard className='padding-top-1 padding-right-1' indeterminate round />
    }
}

DeclarationPointDetails.propTypes = {
    params: PropTypes.shape({
        id: PropTypes.string,
        idDeclaration: PropTypes.string,
        idPoint: PropTypes.string,
    }),
    declaration: PropTypes.instanceOf(DtoDeclaration),
    exploitation: PropTypes.instanceOf(DtoExploitation),
    setTitle: PropTypes.func,
    push: PropTypes.func,
    survey: PropTypes.instanceOf(DtoSurvey),
    installation: PropTypes.instanceOf(DtoInstallation),
    installationsWithGeo: PropTypes.arrayOf(PropTypes.instanceOf(DtoInstallationWithGeoItem)),
    usages: PropTypes.arrayOf(PropTypes.instanceOf(DtoUsageAgri)),
    sandreCodes: PropTypes.arrayOf(PropTypes.instanceOf(DtoSandreCode)),
    fetchExploitationUser: PropTypes.func,
    fetchInstallation: PropTypes.func,
    updateDeclaration: PropTypes.func,
    fetchDeclaration: PropTypes.func,
    fetchUsages: PropTypes.func,
    fetchDeclarationContributors: PropTypes.func,
    fetchContacts: PropTypes.func,
    updateDeclarationContributor: PropTypes.func,
    fetchInstallationsByExploitationId: PropTypes.func,
    warning: PropTypes.func,
    contacts: PropTypes.arrayOf(PropTypes.instanceOf(ContactDto)),
    declarationContributors: PropTypes.arrayOf(PropTypes.instanceOf(DtoIntervenantDeclaration)),
    variousMateriels: PropTypes.arrayOf(PropTypes.instanceOf(DtoVariousMateriel)),
    contributorsIndex: PropTypes.shape({}),
    exploitationsExportFullData: PropTypes.arrayOf(PropTypes.instanceOf(DtoExploitationExportFull)),
}

const mapStateToProps = (store) => {
    return {
        usages: store.UsageReducer.usages,
        installationsWithGeo: store.InstallationReducer.installationsWithGeo,
        installation: store.InstallationReducer.installation,
        declaration: store.AgriReducer.declaration,
        exploitation: store.AgriReducer.exploitation,
        sandreCodes: store.ReferencialReducer.sandreCodes,
        contacts: store.ContactReducer.contacts,
        declarationContributors: store.AgriReducer.declarationContributors,
        variousMateriels: store.VariousMaterielReducer.variousMateriels,
        survey: store.AgriReducer.survey,
        contributorsIndex: store.ContributorReducer.contributorsIndex,
        exploitationsExportFullData: store.AgriReducer.exploitationsExportFullData,
    }
}

const mapDispatchToProps = {
    fetchUsages: UsageAction.fetchUsages,
    fetchExploitationUser: AgriAction.fetchExploitationUser,
    fetchDeclaration: AgriAction.fetchDeclaration,
    updateDeclaration: AgriAction.updateDeclaration,
    fetchDeclarationContributors: AgriAction.fetchDeclarationContributors,
    fetchInstallation: InstallationAction.fetchInstallation,
    setTitle: HomeAction.setTitle,
    fetchContacts: ContactAction.fetchContacts,
    updateDeclarationContributor: AgriAction.updateDeclarationContributor,
    fetchInstallationsByExploitationId: InstallationAction.fetchInstallationsByExploitationId,
    warning: ToastrAction.warning,
    push,
}

export default connect(mapStateToProps, mapDispatchToProps)(DeclarationPointDetails)
